import { useCallback, useRef } from 'react';

type HookReturn = (node: HTMLElement | null) => void;

export function useScrollIntoView(callback?: () => void): HookReturn {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const ref = useRef<HTMLElement | null>(null);

  return useCallback((node: HTMLElement | null) => {
    if (node) {
      ref.current = node;

      if (timerRef.current) clearTimeout(timerRef.current);

      timerRef.current = setTimeout(() => {
        node.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        callback?.();
      }, 500);
    }
  }, []);
}
